import { render, staticRenderFns } from "./OpenQ.vue?vue&type=template&id=9e1424da&"
import script from "./OpenQ.vue?vue&type=script&lang=ts&"
export * from "./OpenQ.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports